<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${networkTypeId ? 'Edit' : 'Add New'} Network Type`" />
    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="networkTypeId" class="custom-label">ID</label>
            <input id="networkTypeId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-9 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" rows="4" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.networkTypeId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>
        <deleteModal v-if="this.networkTypeId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.networkTypeId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button"
              @click="addNetworkTypeData()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addNetworkType, getByIdNetworkType, updateNetworkType } from '@/http/iot-asset/network-type.http'
import deleteModal from '@/components/delete-modal.vue';
export default {
  name: 'network-type-form',
  components: {
    Header,
    Subheader,
    deleteModal
  },
  data() {
    return {
      breadcrumsfirst: "IoT Assets",
      breadcrumslast: "Network Type",
      titleConfig: "Add Network Type",
      saveData: {},
      networkTypeId: this.$route.params.id,
    }
  },
  mounted() {
    if (this.networkTypeId) {
      getByIdNetworkType(this.networkTypeId).then((res) => {
        this.saveData = res
      })
    }
  },
  methods: {
    addNetworkTypeData() {
      if (this.networkTypeId) {
        const payload = {
          uuid: this.$route.params.id,
        };

        updateNetworkType({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/iotassets/networktype")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addNetworkType(this.saveData).then(() => {
          this.$router.push("/iotassets/networktype")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },
    cancelButton() {
      this.$router.push("/iotassets/networktype")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateNetworkType({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/iotassets/networktype")
      }).catch((error) => {
        this.error = error.message;
      });

    },
  }
}
</script>

<style scoped></style>